export enum HeaderComponents {
    CenterTabNavigation = 'CenterTabNavigation',
    EhrCenter = 'EhrCenter',
    NavigationTab = 'NavigationTab',
    BackButton = 'BackButton',
    EntryCenter = 'EntryCenter',
    EntryActionButton = 'EntryActionButton',
    EntryBottom = 'EntryBottom',
    ScheduleCenter = 'ScheduleCenter',
    BlockCenter = 'BlockCenter',
    EntryTypeCenter = 'EntryTypeCenter',
    BlockRight = 'BlockRigth',
    EntryTypeRight = 'EntryTypeRight',
    OrgRightContent = 'OrgRightContent',
    SoapRightContent = 'SoapRightContent',
    DashboardHeaderBottom = 'DashboardHeaderBottom',
}
